import { render, staticRenderFns } from "./practiceFrom.vue?vue&type=template&id=4291d8ae&scoped=true"
import script from "./practiceFrom.vue?vue&type=script&lang=js"
export * from "./practiceFrom.vue?vue&type=script&lang=js"
import style0 from "./practiceFrom.vue?vue&type=style&index=0&id=4291d8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291d8ae",
  null
  
)

export default component.exports